<script>
import CTA from '@phoenix/mixins/components/common/CTA';
import { PhxIcon } from '@phx-styleguides/jlc';
import { showModal } from '@phoenix/helpers/modal-helper';

export default {
  components: {
    PhxIcon,
  },

  mixins: [CTA],

  computed: {
    baseClasses() {
      return ['btn'];
    },

    modalId() {
      return this.target?.type === 'modal' ? this.target.id : null;
    },

    shouldOpenModal() {
      return this.modalId !== null;
    },
  },

  methods: { showModal },
};
</script>

<template>
  <button v-if="shouldOpenModal" v-bind="attributes" :class="getClasses" :data-modal-open="modalId">
    <span class="btn__text" v-html="getText" />
    <span v-if="icon" class="btn__icon">
      <phx-icon :icon="icon" />
    </span>
  </button>
  <a v-else :href="link" v-bind="attributes" :class="getClasses">
    <span class="btn__text" v-html="getText" />
    <span v-if="icon" class="btn__icon">
      <phx-icon :icon="icon" />
    </span>
  </a>
</template>
